import { lazyLoadComponentSilent, loadBundle } from '../../services/LazyLoadComponent';

export default lazyLoadComponentSilent(() => import(/* webpackChunkName: 'Spark' */ '.').then(loadBundle));
